// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"2894fae3","839":"26a9e771"}[chunkId] + ".chunk.js";
};